<modal #modal>
  <div class="col-12 container">
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onCloseClick()">
      &times;
    </button>
    <h1 class="header">Hov! Vi kender dig i forvejen</h1>
    <p>De informationer, du har indtastet, findes allerede i vores system. Det betyder, at du blot skal logge ind via
      MitID</p>
    <button class="btn btn-lg" (click)="onContinueClick()">Fortsæt dit køb her</button>
    <p class="small">Er dette ikke korrekt, så kontakt Kundeservice via vores chat, <a class="link"
        href="mailto:kundeservice@klasselotteriet.dk">mail</a> eller telefon: 3342 0900, mandag-fredag 9.00-18.00.
    </p>
  </div>
</modal>